import { C, mono } from "@/lib/theme";

const ITEMS = [
  "React.js", "FastAPI", "TypeScript", "Node.js", "REST APIs", "Tailwind CSS",
  "GSAP", "PHP", "MySQL", "MongoDB", "SCSS", "Figma → Build", "Technical SEO", "Custom WordPress",
];

const Group = () => (
  <span style={{ display: "flex", gap: 30, paddingRight: 30 }}>
    {ITEMS.map((it, i) => (
      <span key={i} style={{ display: "flex", gap: 30, alignItems: "center" }}>
        <span>{it}</span>
        <span style={{ color: C.accent }}>✦</span>
      </span>
    ))}
  </span>
);

const Marquee = () => (
  <div
    data-testid="tech-marquee"
    style={{ overflow: "hidden", borderBottom: `1px solid ${C.border}`, background: C.bgCard, padding: "15px 0" }}
  >
    <div
      style={{
        display: "flex",
        width: "max-content",
        animation: "aw-mq 44s linear infinite",
        fontFamily: mono,
        fontSize: 11.5,
        letterSpacing: "0.22em",
        textTransform: "uppercase",
        color: C.text56,
      }}
    >
      <Group />
      <Group />
    </div>
  </div>
);

export default Marquee;
